__turbopack_context__.v({
  "author": "styles-module-scss-module__nd0hFG__author",
  "date": "styles-module-scss-module__nd0hFG__date",
  "description": "styles-module-scss-module__nd0hFG__description",
  "metadata": "styles-module-scss-module__nd0hFG__metadata",
  "restrictedSection": "styles-module-scss-module__nd0hFG__restrictedSection",
  "restrictedSectionDescription": "styles-module-scss-module__nd0hFG__restrictedSectionDescription",
  "restrictedSectionTitle": "styles-module-scss-module__nd0hFG__restrictedSectionTitle",
  "restrictedSectionTitleIcon": "styles-module-scss-module__nd0hFG__restrictedSectionTitleIcon",
  "restrictedSectionsContainer": "styles-module-scss-module__nd0hFG__restrictedSectionsContainer",
  "tagItem": "styles-module-scss-module__nd0hFG__tagItem",
  "title": "styles-module-scss-module__nd0hFG__title",
});
